/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
//  import styled from "styled-components";

// Bootstrap
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Alert from "react-bootstrap/Alert";
// Componentes
import Notification from "../../components/notification";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { httpClient } from "../../utils/HttpClient";
import CampaignMessageEdit from "./_CampaignMessageEdit";
import WhatsappMessageControl from "../../components/generic/_WhatsappMessageControl";
import EmailMessageControl from "../../components/generic/_EmailMessageControl";
import RcsMessageControl from "../../components/generic/_RcsMessageControl";
import Icon from "../../components/Icon";
import { classNames } from "../../utils/helpers";
// migrar a formik para el manejo de formularios y validaciones
//import { useFormik } from "formik";
var today = moment(new Date()).format().split("T")[0];
//var today2 = new Date().toISOString().split("T")[0];
import PropTypes from "prop-types";
import { generateRandomUUID } from "../../utils/helpers";

const ChannelForm = (props) => {
  const {
    isActive,
    setIsActive,
    values,
    onChange,
    listShortLinks,
    fieldsInfo,
    clickLink,
    setValues,
    isDisabled,
    showPrev,
    datosGenerales,
    title = "",
    icon = "",
    value = "",
  } = props;

  const renderChannel = () => {
    if (!value) return null;
    if (value === "SMS")
      return (
        <>
          <CampaignMessageEdit
            isSMS={true}
            isWhatsApp={false}
            isEmail={false}
            values={values}
            onChange={onChange}
            listShortLinks={listShortLinks}
            fieldsInfo={fieldsInfo}
            clickLink={clickLink}
            setValues={setValues}
            isDisabled={isDisabled}
          />
          {values.template && showPrev && (
            <>
              <h5 className="PrevTitleModal">Previsualización:</h5>
              <div className="contenedo_msj">
                <div className="mensaje-izq">
                  <div className="cuerpo_msj">
                    {isActive ? (
                      <div className="msj-texto">{values.template}</div>
                    ) : (
                      <div
                        className="msj-texto"
                        dangerouslySetInnerHTML={{
                          __html: values.template,
                        }}
                      ></div>
                    )}
                  </div>
                </div>
                <Badge
                  className="mt-2"
                  style={{ minWidth: "143px" }}
                  bg="secondary"
                >
                  Max. Caracteres: {values.template.length}
                </Badge>
              </div>
              <hr />
            </>
          )}
        </>
      );

    if (value === "whatsapp")
      return (
        <WhatsappMessageControl
          values={values}
          onChange={onChange}
          fieldsInfo={fieldsInfo}
          setValues={setValues}
        />
      );

    if (value === "email")
      return (
        <EmailMessageControl
          name="mailmessage"
          values={values}
          setValues={setValues}
          listShortLinks={listShortLinks}
          fieldsInfo={fieldsInfo}
          defaultValue={values.mailmessage}
          onChange={onChange}
        />
      );

    if (value === "RCS")
      return (
        <>
          <RcsMessageControl
            name="rcsmessage"
            values={values}
            setValues={setValues}
            listShortLinks={listShortLinks}
            fieldsInfo={fieldsInfo}
            defaultValue={values.rcsmessage}
            onChange={onChange}
          />
          {values.rcsmessage && showPrev && (
            <>
              <h5 className="PrevTitleModal">Previsualización:</h5>
              <div className="contenedo_msj">
                <div className="mensaje-izq">
                  <div className="cuerpo_msj">
                    {isActive ? (
                      <div className="msj-texto">{values.rcstemplate}</div>
                    ) : (
                      <div
                        className="msj-texto"
                        dangerouslySetInnerHTML={{
                          __html: values.rcstemplate,
                        }}
                      ></div>
                    )}
                  </div>
                </div>
                <Badge
                  className="mt-2"
                  style={{ minWidth: "143px" }}
                  bg="secondary"
                >
                  Max. Caracteres: {values.rcstemplate.length}
                </Badge>
              </div>
              <hr />
            </>
          )}
        </>
      );

    if (value === "schedule")
      return (
        <>
          <FloatingLabel label="Fecha de envío:" className="mb-3">
            <Form.Control
              type="date"
              name="dateSend"
              id="dateSend"
              placeholder="Programar"
              min={today}
              onChange={(event) => {
                onChange(event);
              }}
              required
            />
          </FloatingLabel>
          <FloatingLabel label="Hora de envío:" className="mb-3">
            <Form.Control
              type="time"
              name="proghour"
              id="proghour"
              placeholder="Programar"
              onChange={(event) => {
                onChange(event);
              }}
              required
            />
          </FloatingLabel>
          <Alert key={"secondary"} variant={"secondary"} className="Notice">
            <b>Nota:</b> Si la hora seleccionada ya transcurrió la campaña se
            ejecutará inmediatamente.
          </Alert>
        </>
      );

    return <div className="card px-4 py-2">Canal no definido</div>;
  };

  return (
    <div>
      {" "}
      <div className="bg-white border rounded-xl px-4 py-2 border-slate-200 my-2">
        <div className="flex pt-2 items-center justify-between">
          <div className="flex justify-center">
            {icon ? <Icon icon={icon} size={24} /> : null}
            <h3 className="text-[18px] font-medium px-2">{title}</h3>
          </div>

          <Form.Check
            type="switch"
            id="isSms"
            checked={isActive}
            onChange={() => setIsActive(!isActive)}
            className="prevent-validation"
            disabled={
              !datosGenerales?.uiddatabase || !datosGenerales?.campaingName
            }
          />
        </div>

        <div className="w-full">{isActive ? renderChannel() : null}</div>
      </div>
    </div>
  );
};

const NewCampaignMulti = () => {
  //const Formik = useFormik();
  const Auth = useAuth();
  const channel = Auth.getUserChannel();
  var userData = Auth.getSessionData();

  const navigate = useNavigate();
  const [masksList, setMasksList] = useState(null);
  const [buttonText, setButtonText] = useState("Enviar");
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [listShortLinks, setListShortLinks] = useState(false);
  const [show, setShow] = useState(false);
  const [showPrev, setShowPrev] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [listDatabases, setListDatabases] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [notificationType, setNotificationType] = useState("");
  const [fieldsInfo, setFieldsInfo] = useState(false);
  const [isSms, setIsSms] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [isRcs, setIsRcs] = useState(false);

  const [messageNotification, setMessageNotification] =
    useState("Campaña creada");
  const [values, setValues] = useState({
    campaingName: "",
    uiddatabase: "",
    message: "",
    dateSend: "",
    msisdn: "",
    proghour: "",
    template: "",
    idshortcode: "0",
    mask: "",
    whmessage: "",
    mailmessage: "",
    rcsmessage: "",
  });
  const [datosGenerales, setDatosGenerales] = useState({
    campaingName: "",
    uiddatabase: "",
  });

  const getListDatabases = (uidpartner) => {
    const URI = ApiEndpoint + "campaigns/getPartnerDatabasesActive";

    httpClient(
      "POST",
      URI,
      {
        id: `${uidpartner}`,
        iduser: userData.uid_user,
      },
      userData.token
    ).then((response) => {
      setListDatabases(response.data);
    });
  };

  const getShortLinks = () => {
    const URI = ApiEndpoint + "campaigns/shortLinks/" + userData.uid_partner;

    httpClient("GET", URI, {}, userData.token).then((response) => {
      setListShortLinks(response.data.filter((x) => x.active));
    });
  };

  const getXtraFieldsInfo = (uidDatabase) => {
    const URIFields = ApiEndpoint + "campaigns/fieldsdatabase/";

    httpClient("GET", URIFields + uidDatabase, {}, userData.token).then(
      (response) => {
        setFieldsInfo(response.data);
      }
    );
  };

  useEffect(() => {
    if (!values.uiddatabase) return;
    getXtraFieldsInfo(values.uiddatabase);
  }, [values.uiddatabase]);

  useEffect(() => {
    if (!fieldsInfo) {
      setShowPrev(true);
      return;
    }
    let messageWithTemplate = values.message;

    let result;

    var pattern = RegExp("{(.*?)}", "g");
    while ((result = pattern.exec(messageWithTemplate))) {
      // Do something with result[0].

      try {
        var currentK = fieldsInfo.filter(
          (item) => "{" + item.vc_keycolumn + "}" == result[0]
        );
        console.log(currentK);
        messageWithTemplate = messageWithTemplate.replace(
          result[0],
          currentK[0].vc_value
        );
      } catch (error) {
        console.log(error);
      }
    }

    setValues({
      ...values,
      ["template"]: messageWithTemplate.replaceAll("{", "").replaceAll("}", ""),
    });
  }, [values.message]);

  useEffect(() => {
    getListDatabases(userData.uid_partner);
  }, []);

  useEffect(() => {
    //  getCarriersList();
    getShortLinks();
    getAvMask();
  }, []);

  const handleSubmit1 = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    let jDetails = {};
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    setIsBtnDisabled(true);
    setButtonText("Enviando...");

    if (isWhatsApp) {
      jDetails = {
        parameters: values.whparameters + ",",
        template: values.selectedTemplate,
      };
    }

    let URICustomer = ApiEndpoint + "campaigns/createCampaign";
    if (isScheduled) {
      URICustomer = ApiEndpoint + "campaigns/programCampaign";
    }
    //getListDatabases(userData.uid_partner);
    setMessageNotification("Campaña creada");
    setNotificationType("success");
    var dataToSubmit = {
      name: values.campaingName,
      uiddatabase: values.uiddatabase,
      partner: `${userData.uid_partner}`,
      message: values.message,
      send: values.dateSend,
      hour: isScheduled ? values.proghour.split(":")[0] : 0,
      minute: isScheduled ? values.proghour.split(":")[1] : 0,
      uidUser: userData.uid_user,
      idshortcodemask: values.idshortcode > 0 ? values.idshortcode : null,
      mask: values.mask,
      subject: values.subject,
      isSms: isSms,
      isEmail: isEmail,
      isRcs: isRcs,
      isWhatsapp: isWhatsApp,
      jDetails: JSON.stringify(jDetails),
      emailmessage: values.mailmessage,
      rcsmessage: values.rcsmessage,
      uuid_campaign: generateRandomUUID()
    };
    console.log("dataToSubmit", dataToSubmit);

    httpClient("POST", URICustomer, dataToSubmit, userData.token)
      .then(function (response) {
        if (response.data.error) {
          setMessageNotification(
            response.data.Errorcode == "0"
              ? "No cuenta con SMS suficientes para la campaña"
              : "Ya existe una campaña con ese nombre"
          );
          setNotificationType("warning");
          setShow(true);
          setIsBtnDisabled(false);
          setValidated(false);
          setButtonText("Enviar");
        } else {
          setMessageNotification("Campaña creada");
          setNotificationType("");
          setShow(true);
          navigate("/Campaigns");
        }
        return;
      })
      .catch(function (error) {
        setMessageNotification("Ha ocurrido un error");
        setNotificationType("warning");
        setShow(true);

        setIsBtnDisabled(false);
        setButtonText("Enviar");
        console.log(error);
      });
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    // getCarriersList();
    getShortLinks();
    //getShortCodes();
  }, []);

  // const getShortCodes = () => {
  //   const URI = ApiEndpoint + "administration/shortcodesbypartner/";
  //   httpClient("GET", URI + `${userData.uid_partner}`, {}, userData.token).then(
  //     (response) => {
  //       setShortCodesList(response.data);
  //     }
  //   );
  // };

  const getAvMask = () => {
    const URI = ApiEndpoint + "campaigns/masks/";
    httpClient("GET", URI + `${userData.uid_partner}`, {}, userData.token).then(
      (response) => {
        setMasksList(response.data);
      }
    );
  };

  const clickLink = (link) => {
    //  setMessageText(link);
    setValues({
      ...values,
      message: values.message + " " + link + " ",
      template: values.template + " " + link + " ",
    });
  };

  const CHANNELS = [
    {
      isActive: isSms,
      setIsActive: setIsSms,
      title: "SMS",
      icon: "settings",
      value: "SMS",
    },
    {
      isActive: isWhatsApp,
      setIsActive: setIsWhatsApp,
      title: "Whatsapp",
      icon: "settings",
      value: "whatsapp",
    },
    {
      isActive: isEmail,
      setIsActive: setIsEmail,
      title: "Email",
      icon: "settings",
      value: "email",
    },
    {
      isActive: isRcs,
      setIsActive: setIsRcs,
      title: "RCS",
      icon: "settings",
      value: "RCS",
    },
    {
      isActive: isScheduled,
      setIsActive: setIsScheduled,
      title: "Programación de la campaña (Opcional)",
      icon: "schedule",
      value: "schedule",
    },
  ];
  const disabledButton = useMemo(() => {
    const { uiddatabase, campaingName } = datosGenerales;
    if (!uiddatabase || !campaingName) {
      return true;
    }

    return false;
  }, [datosGenerales, values]);

  return (
    <>
      <div className="">
        <div className=" flex justify-between my-3 py-3 mt-2">
          <h2 className="font-[800] text-[18px] text-gray-800">
            Nueva campaña
          </h2>
        </div>
        <Form noValidate validated={validated} onSubmit={handleSubmit1}>
          <div className="px-4 py-3 border rounded-lg bg-white mb-1">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-[800] text-[18px] text-gray-800">
                Datos Generales
              </h3>
              <div className="flex items-center gap-2 px-2">
                <button
                  className={classNames(
                    "bg-blue-500 flex items-center gap-2 rounded-lg border-none px-5 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-600",
                    {
                      "opacity-50 cursor-not-allowed":
                        disabledButton || !isBtnDisabled,
                      "opacity-100 cursor-pointer":
                        !disabledButton || isBtnDisabled,
                    }
                  )}
                  disabled={disabledButton || isBtnDisabled}
                  type="submit"
                >
                  {buttonText}
                  <Icon icon="send" size={20} color="white" />
                </button>
              </div>
            </div>

            <FloatingLabel label="Nombre de la campaña *" className="mb-3">
              <Form.Control
                type="text"
                name="campaingName"
                id="campaingName"
                value={values.campaingName}
                required
                onChange={(event) => {
                  onChange(event);
                  setDatosGenerales({
                    ...datosGenerales,
                    campaingName: event.target.value,
                  });
                }}
                placeholder="Nombre de la campaña *"
              />
            </FloatingLabel>

            <FloatingLabel label="Base de datos *" className="mb-3">
              <Form.Select
                id="uiddatabase"
                name="uiddatabase"
                value={values.uiddatabase}
                required
                aria-label="select_carrier"
                onChange={(event) => {
                  onChange(event);
                  setIsDisabled(false);
                  setDatosGenerales({
                    ...datosGenerales,
                    uiddatabase: event.target.value,
                  });
                }}
              >
                <option value="">Seleccione una opcion de la lista</option>
                {!!listDatabases?.length &&
                  listDatabases.map((item) => (
                    <option key={item.uiddatabase} value={item.uiddatabase}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </FloatingLabel>
            <FloatingLabel label="Mascara (opcional)" className="mb-3">
              <Form.Select
                id="mask"
                name="mask"
                onChange={(selectedOption) => {
                  onChange(selectedOption);
                }}
                value={values.mask}
                aria-label="select_mask"
              >
                <option value="">Predeterminada</option>
                {!!masksList?.length &&
                  masksList.map((mask) => (
                    <option key={mask.vc_mask} value={mask.vc_mask}>
                      {mask.vc_mask}
                    </option>
                  ))}
              </Form.Select>
            </FloatingLabel>
            <div></div>
          </div>

          {CHANNELS.filter((item) =>
            [...channel, "schedule"].includes(item.value.toUpperCase()) || channel.includes("ALL")
          ).map((channel, index) => (
            <ChannelForm
              key={index}
              isActive={channel.isActive}
              setIsActive={channel.setIsActive}
              title={channel.title}
              icon={channel.icon}
              value={channel.value}
              values={values}
              onChange={onChange}
              listShortLinks={listShortLinks}
              fieldsInfo={fieldsInfo}
              clickLink={clickLink}
              setValues={setValues}
              isDisabled={isDisabled}
              showPrev={showPrev}
              datosGenerales={datosGenerales}
            />
          ))}
        </Form>
      </div>

      <Notification
        alertType={notificationType}
        show={show}
        setShow={setShow}
        message={messageNotification}
      />
    </>
  );
};

ChannelForm.propTypes = {
  isActive: PropTypes.bool.isRequired,
  setIsActive: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  listShortLinks: PropTypes.array,
  fieldsInfo: PropTypes.array,
  clickLink: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  showPrev: PropTypes.bool.isRequired,
  datosGenerales: PropTypes.object,
  icon: PropTypes.string.optional,
  value: PropTypes.string,
};
export default NewCampaignMulti;
